// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lottie-container[data-v-6d0d3bae]{align-items:center;display:flex;flex-direction:column;justify-content:center;margin:auto}.lottie-container--absolute[data-v-6d0d3bae]{bottom:0;justify-content:center;left:0;position:absolute;right:0;top:0}.lottie-container h2[data-v-6d0d3bae]{text-align:center}#lottie[data-v-6d0d3bae]{max-height:calc(100vh - 64px);max-width:95vw;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
